const pendingStylesheets = new Map<string, Promise<void>>();

const MAIN_SCRIPT_HASH = /\/main[.-]([a-z0-9]+)\.js/i;

function buildHashQuery(): string {
  const mainScript = Array.from(document.scripts)
    .map((script) => script.src)
    .find((src) => MAIN_SCRIPT_HASH.test(src));
  const hash = mainScript?.match(MAIN_SCRIPT_HASH)?.[1];
  return hash ? `?v=${hash}` : '';
}

function insertAfterGlobalStyles(link: HTMLLinkElement): void {
  const firstComponentStyle = document.head.querySelector('style[ng-app-id]');
  const globalStyles = document.head.querySelector('link[rel="stylesheet"][href^="styles"]');
  if (firstComponentStyle) {
    firstComponentStyle.before(link);
  } else if (globalStyles) {
    globalStyles.after(link);
  } else {
    document.head.appendChild(link);
  }
}

export function loadLazyStylesheet(bundleName: string): Promise<void> {
  const pending = pendingStylesheets.get(bundleName);
  if (pending) {
    return pending;
  }

  const loading = new Promise<void>((resolve) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${bundleName}.css${buildHashQuery()}`;
    link.onload = () => resolve();
    link.onerror = () => {
      link.remove();
      pendingStylesheets.delete(bundleName);
      resolve();
    };
    insertAfterGlobalStyles(link);
  });
  pendingStylesheets.set(bundleName, loading);
  return loading;
}
